/** 데모/영업용 샘플 테스트 계정 소속 (더미 데이터 화면 전용) */
const SAMPLE_ACCOUNT_ORGANIZATION = "테스트";

/**
 * 실 데이터 연동 없이 더미 데이터 기반 샘플 화면(SampleAdminView)을 보여줘야 하는 계정인지 판별합니다.
 * - level === 10 인 계정
 * - 소속(organization)이 "테스트" 인 계정
 * @param {object} me - 로그인한 관리자 정보
 * @returns {boolean}
 */
export const isSampleAccount = (me) =>
  Number(me?.level) === 10 ||
  me?.organization?.trim() === SAMPLE_ACCOUNT_ORGANIZATION;

/** 마스터 관리자(level === 0) 여부 */
export const isMasterAccount = (me) => me?.level === 0;

/**
 * 단일 code 없이, 소속(기관) 산하 여러 사업을 한 번에 조회해야 하는 "기관 관리자" 여부.
 * 서버가 로그인 토큰의 소속/level을 바탕으로 /sidebar 응답 범위를 이미 걸러서 내려주므로,
 * 프론트는 이 여부만 판단해 마스터 관리자와 동일한 사이드바 트리(organizations)를 그대로 그리면 됨.
 */
export const isOrgLevelAdmin = (me) =>
  !isMasterAccount(me) && !isSampleAccount(me) && !me?.code;

/**
 * 마스터 관리자가 아니면서 "월성복지관" 소속이고 level === 5인 관리자 여부.
 * 해당 관리자에게는 위험(자살·자해 위험 감지) 관련 정보를 노출하지 않습니다.
 */
export const isRiskInfoRestrictedAdmin = (me) =>
  !isMasterAccount(me) && me?.organization === "월성복지관" && Number(me?.level) === 5;
